var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{style:(_vm.isMobileMode && _vm.isSubMenuVisible && !_vm.hideSubMenu && _vm.isFirstClick? 'margin-left: 256px': '')},[_c('router-view',{attrs:{"id":"content"}}),_c('dashboard-core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }